"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LineString = _interopRequireDefault(require("../geom/LineString"));

var _BoundaryNodeRule = _interopRequireDefault(require("../algorithm/BoundaryNodeRule"));

var _CoordinateArrays = _interopRequireDefault(require("../geom/CoordinateArrays"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

var _TreeMap = _interopRequireDefault(require("../../../../java/util/TreeMap"));

var _MultiLineString = _interopRequireDefault(require("../geom/MultiLineString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BoundaryOp =
/*#__PURE__*/
function () {
  function BoundaryOp() {
    _classCallCheck(this, BoundaryOp);

    BoundaryOp.constructor_.apply(this, arguments);
  }

  _createClass(BoundaryOp, [{
    key: "boundaryMultiLineString",
    value: function boundaryMultiLineString(mLine) {
      if (this._geom.isEmpty()) {
        return this.getEmptyMultiPoint();
      }

      var bdyPts = this.computeBoundaryCoordinates(mLine);

      if (bdyPts.length === 1) {
        return this._geomFact.createPoint(bdyPts[0]);
      }

      return this._geomFact.createMultiPointFromCoords(bdyPts);
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      if (this._geom instanceof _LineString.default) return this.boundaryLineString(this._geom);
      if (this._geom instanceof _MultiLineString.default) return this.boundaryMultiLineString(this._geom);
      return this._geom.getBoundary();
    }
  }, {
    key: "boundaryLineString",
    value: function boundaryLineString(line) {
      if (this._geom.isEmpty()) {
        return this.getEmptyMultiPoint();
      }

      if (line.isClosed()) {
        var closedEndpointOnBoundary = this._bnRule.isInBoundary(2);

        if (closedEndpointOnBoundary) {
          return line.getStartPoint();
        } else {
          return this._geomFact.createMultiPoint();
        }
      }

      return this._geomFact.createMultiPoint([line.getStartPoint(), line.getEndPoint()]);
    }
  }, {
    key: "getEmptyMultiPoint",
    value: function getEmptyMultiPoint() {
      return this._geomFact.createMultiPoint();
    }
  }, {
    key: "computeBoundaryCoordinates",
    value: function computeBoundaryCoordinates(mLine) {
      var bdyPts = new _ArrayList.default();
      this._endpointMap = new _TreeMap.default();

      for (var i = 0; i < mLine.getNumGeometries(); i++) {
        var line = mLine.getGeometryN(i);
        if (line.getNumPoints() === 0) continue;
        this.addEndpoint(line.getCoordinateN(0));
        this.addEndpoint(line.getCoordinateN(line.getNumPoints() - 1));
      }

      for (var it = this._endpointMap.entrySet().iterator(); it.hasNext();) {
        var entry = it.next();
        var counter = entry.getValue();
        var valence = counter.count;

        if (this._bnRule.isInBoundary(valence)) {
          bdyPts.add(entry.getKey());
        }
      }

      return _CoordinateArrays.default.toCoordinateArray(bdyPts);
    }
  }, {
    key: "addEndpoint",
    value: function addEndpoint(pt) {
      var counter = this._endpointMap.get(pt);

      if (counter === null) {
        counter = new Counter();

        this._endpointMap.put(pt, counter);
      }

      counter.count++;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return BoundaryOp;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "getBoundary",
    value: function getBoundary() {
      if (arguments.length === 1) {
        var g = arguments[0];
        var bop = new BoundaryOp(g);
        return bop.getBoundary();
      } else if (arguments.length === 2) {
        var _g = arguments[0],
            bnRule = arguments[1];
        var bop = new BoundaryOp(_g, bnRule);
        return bop.getBoundary();
      }
    }
  }]);

  return BoundaryOp;
}();

exports.default = BoundaryOp;

BoundaryOp.constructor_ = function () {
  this._geom = null;
  this._geomFact = null;
  this._bnRule = null;
  this._endpointMap = null;

  if (arguments.length === 1) {
    var geom = arguments[0];
    BoundaryOp.constructor_.call(this, geom, _BoundaryNodeRule.default.MOD2_BOUNDARY_RULE);
  } else if (arguments.length === 2) {
    var _geom = arguments[0],
        bnRule = arguments[1];
    this._geom = _geom;
    this._geomFact = _geom.getFactory();
    this._bnRule = bnRule;
  }
};

var Counter =
/*#__PURE__*/
function () {
  function Counter() {
    _classCallCheck(this, Counter);

    Counter.constructor_.apply(this, arguments);
  }

  _createClass(Counter, [{
    key: "getClass",
    value: function getClass() {
      return Counter;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return Counter;
}();

Counter.constructor_ = function () {
  this.count = null;
};